<template>
  <div class="contact-container">
    <MyHeader :bg="bgUrl" :name="$isCN() ? '联系我们' : 'Contact us'" :nameSecond="$isCN() ? 'Contact us' : ''" />
    <div id="page2-partical"></div>
    <div class="page-content">
      <div :id="$i18Id($t('主要办公地点'))"></div>
      <SectionTitle title="主要办公地点" titleEN="Offices" class="mt-90" />
      <div class="workspace">
        <div class="item">
          <www-picture
            :noCompress="true"
            class="img common-animation-img"
            w="420"
            h="250"
            img="//res-fengche.souche.com/f2e/5126ef469e023aa9de263f4e36cfb5d5.png"
          />
          <div class="txt-container" v-if="!isEN">
            <div class="title">北京</div>
            <div class="sub">
              <div class="label">电话：</div>
              <div class="value">010-56212779</div>
            </div>
            <div class="sub">
              <div class="label">地址：</div>
              <div class="value">北京市朝阳区酒仙桥街道14号兆维工业园C2-1（5层、6层）</div>
            </div>
          </div>
          <div class="txt-container" v-else>
            <div class="title">Beijing</div>
            <div class="sub">
              <!-- <div class="label label-en">Tel</div> -->
              <!-- <span>: </span> -->
              <div class="value value-en">(86) 10-56212779</div>
            </div>
            <div class="sub">
              <!-- <div class="label label-en">Address</div> -->
              <!-- <span>: </span> -->
              <div class="value value-en">
                F5 & F6, Building C2-1, Zhaowei Industrial Park, 14 Jiuxianqiao Street, Chaoyang District, Beijing
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <www-picture
            :noCompress="true"
            class="img common-animation-img"
            w="420"
            h="250"
            img="//res-fengche.souche.com/f2e/7af9f43df3d0f5d360227b4556e1b236.png"
          />
          <div class="txt-container" v-if="!isEN">
            <div class="title">杭州</div>
            <div class="sub">
              <div class="label">电话：</div>
              <div class="value">0571-88607326</div>
            </div>
            <div class="sub">
              <div class="label">地址：</div>
              <div class="value">浙江省杭州市余杭区五常大道175号</div>
            </div>
          </div>
          <div class="txt-container" v-else>
            <div class="title">Hangzhou</div>
            <div class="sub">
              <!-- <div class="label label-en">Tel</div> -->
              <!-- <span>: </span> -->
              <div class="value value-en">(86) 571-88607326</div>
            </div>
            <div class="sub">
              <!-- <div class="label label-en">Addr.</div> -->
              <!-- <span>: </span> -->
              <div class="value value-en">175 Wuchang Avenue, Yuhang District, Hangzhou, Zhejiang</div>
            </div>
          </div>
        </div>
      </div>
      <div :id="$i18Id($t('合作洽谈'))"></div>
      <SectionTitle title="合作洽谈" titleEN="Contacts" class="mt-90" />
      <div class="cooperation" v-if="!isMobile">
        <div class="layer1 common-animation-container">
          <template v-if="!isEN">
            <div class="group">
              <span class="item"><strong>媒体垂询</strong></span>
              <span class="item"><strong>投融资相关</strong></span>
              <span class="item"><strong>车商业务合作</strong></span>
              <span class="item"><strong>品牌合作、市场推广</strong></span>
            </div>
            <div class="group">
              <span class="item">pr@souche.com</span>
              <span class="item">ir@souche.com</span>
              <span class="item">ucd@souche.com</span>
              <span class="item">marketingbd@souche.com</span>
            </div>
          </template>
          <template v-else>
            <div class="cooperation-info" v-if="isEN">
              <div class="mb-16"><strong>For media inquiries</strong><br />pr@souche.com</div>
              <div class="mb-16"><strong>For investment and financing related matters</strong><br />ir@souche.com</div>
              <div class="mb-16">
                <strong>For car business cooperation</strong><br />
                ucd@souche.com
              </div>
              <div><strong>For brand cooperation and marketing promotion</strong><br />marketingbd@souche.com</div>
            </div>
          </template>
        </div>
        <div class="layer2"></div>
        <www-picture class="layer3 common-animation-img" w="480" h="310" img="//res-fengche.souche.com/f2e/6ba4a6cd6d0055fc762c38cc08a96439.png" />
      </div>
      <div v-else class="cooperation-mob">
        <img class="cooperation-mob-img" src="//res-fengche.souche.com/f2e/6ba4a6cd6d0055fc762c38cc08a96439.png" />
        <div class="cooperation-mob-info" v-if="isEN">
          <div class="mb-16"><strong>For media inquiries</strong><br />pr@souche.com</div>
          <div class="mb-16"><strong>For investment and financing related matters</strong><br />ir@souche.com</div>
          <div class="mb-16">
            <strong>For car business cooperation</strong><br />
            ucd@souche.com
          </div>
          <div><strong>For brand cooperation and marketing promotion</strong><br />marketingbd@souche.com</div>
        </div>
        <pre class="cooperation-mob-info" v-else>
    <strong>媒体垂询</strong>
    请联系：pr@souche.com

    <strong>投融资相关</strong>
    请联系：ir@souche.com

    <strong>车商业务合作</strong>
    请联系：ucd@souche.com

    <strong>品牌合作、市场推广</strong>
    请联系：marketingbd@souche.com
  </pre
        >
      </div>
      <div :id="$i18Id($t('廉政合规'))" class="anchor_trans_small"></div>
      <SectionTitle title="廉政合规" titleEN="Integrity & Compliance" class="integrity" />
      <span class="compliance">{{ $t("compliance") }}</span>
      <a href="mailto:lianzheng@souche.com" class="send-email">{{ isEN ? "Email Us" : "给我们发邮件" }} →</a>
    </div>
    <div :id="$i18Id($t('加入我们'))"></div>
    <div class="join-us-root">
      <img
        v-if="!isMobile"
        class="img-so"
        w="574"
        h="496"
        src="//res-fengche.souche.com/bolt/C4DPjtmW5YGEcU-bUw4GO/%E5%BA%95%E9%83%A8%E5%B0%8F%E6%90%9C%20(1).png"
      />
      <img
        v-else
        class="img-so"
        w="574"
        h="496"
        src="//res-fengche.souche.com/bolt/n1o1UOwe9T1Jc-lG2pSTn/%E5%BA%95%E9%83%A8%E5%B0%8F%E6%90%9C%20(2)%20(1).png"
      />
      <div class="info">
        <div class="title">
          <span v-if="isEN">Welcome to join us</span>
          <span v-if="!isEN">欢迎加入我们</span>
          <div class="bg"></div>
          <img src="//res-fengche.souche.com/bolt/aXj7YnIdmpAOAOGwuDJ85/arrow-left-double-line%201.png" class="arrow-job" />
        </div>
        <span class="sub" v-if="!isEN">Join Us</span>
        <span class="contact" v-if="isEN && isMobile">Please contact:<br />hr@souche.com</span>
        <span class="contact" v-else>{{ isEN ? "Please contact: hr@souche.com" : "请联系：hr@souche.com" }}</span>
      </div>
    </div>
    <div class="jobs">
      <div class="job-card">
        <div class="top">产研类</div>
        <div class="list">
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F719eebdd-2d98-4fda-a83c-410e5949d292%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >AI算法高级专家（二手车产业智能化方向）</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2Fc0e2bf26-669d-4405-ae2f-e48a637d61a3%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >AI业务产品架构师（汽车产业SaaS方向）</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F30b6aa5b-3a31-4163-9275-67a10d338de7%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >JAVA工程师</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F260b071a-dce7-4b82-8bc5-46b288fcb706%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >前端工程师</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2Ffd32f6f4-c4df-4aea-9e95-d69bbcc47bfe%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >测试工程师</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F81e15552-cee5-42cd-afd5-5de4d73e84db%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >产品经理</a
          >
        </div>
      </div>
      <div class="job-card job-card-2">
        <div class="top">运营类</div>
        <div class="list">
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F33235e32-3548-43c9-bc63-47407e79146e%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >检测主管</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F82d971bb-1200-400d-8ea4-eb309ccf9b53%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >检测师</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2Fabfa56ca-b400-432a-b5ba-a6fc9cde0944%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >中台审核</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F3f8768b9-15b6-4401-9120-25ee9c72f5e0%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >总经理助理</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F67b0ec9f-fd6f-48c8-8113-e1d32eaf4296%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >业务助理（数据分析）</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2Febc6a586-94d5-4274-b45b-e960884beeb4%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >运力调度专员</a
          >
        </div>
      </div>
      <div class="job-card job-card-3">
        <div class="top">销售类</div>
        <div class="list">
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F040b517e-ce30-4828-a22f-2b66349f83fd%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >业务拓展顾问</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2F61b65851-075a-4e83-a811-6203e23c61bd%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >商业终端指导顾问</a
          >
          <a
            href="https://app.mokahr.com/m/social-recruitment/souche/3018?hash=%23%2Fjob%2Fa8d329a7-02e6-4c17-b60a-e7de2f53ce0e%3Ffrom%3Dqrcode"
            target="_blank"
            class="item"
            >客户成功顾问</a
          >
        </div>
      </div>
    </div>
    <MyFooter />
  </div>
</template>

<script>
import MyHeader from "../../../../components/MyHeader.vue";
import MyFooter from "../../../../components/MyFooter.vue";
import GroupHead from "../../../../components/GroupHead.vue";
import SectionTitle from "../../../../components/SectionTitle.vue";
import { createData } from "../../../../data/partical-data";

export default {
  computed: {
    bgUrl() {
      return this.$store.state.isMobileSite
        ? "//res-fengche.souche.com/f2e/ab152973e7a99c1ca047fb5e99f61568.png"
        : "//res-fengche.souche.com/f2e/3f77e97c82db03b63c566409c22c853a.jpg";
    },
    isMobile() {
      return this.$store.state.isMobileSite;
    },
    isEN() {
      return this.$i18n.locale === "en";
    },
  },
  methods: {
    async loadEffects() {
      if (this.isMobile) {
        return;
      }
      import("../../../../utils/particles").then(() => {
        window.particlesJS("page2-partical", createData("#b2b2b2", "#b2b2b2"));
      });
    },
  },
  mounted() {
    this.loadEffects();
  },
  i18n: {
    messages: {
      zh: {
        title: "联系我们",
        主要办公地点: "主要办公地点",
        合作洽谈: "合作洽谈",
        廉政合规: "廉政合规",
        加入我们: "加入我们",
        compliance:
          "大搜车所有业务活动都必须严格遵守相关法律法规以及公司行为准则，公司杜绝任何违法、违规或不正当的行为。如果您有任何有关大搜车集团员工与合作伙伴在商业活动中存在不合规、不诚信、不道德行为的信息，欢迎您随时联系大搜车集团廉政合规部。邮箱：lianzheng@souche.com。我们将根据您提供的相关信息，在法律法规及公司有关制度范围内进行调查取证。如确有违规行为，大搜车将严厉查处。",
      },
      en: {
        title: "CONTACT US",
        主要办公地点: "Offices",
        合作洽谈: "Contacts",
        廉政合规: "Integrity & Compliance",
        加入我们: "Join Us",
        compliance:
          "All business activities of DaSouChe Group must strictly comply with relevant laws, regulations, and the company's code of conduct. The company prohibits any illegal, irregular, or unethical behavior. If you have any information regarding non-compliant, dishonest, or unethical behavior by DaSouChe Group employees and partners during business activities, please feel free to contact the DaSouChe Group's Compliance Department at lianzheng@souche.com. We will investigate and gather evidence based on the relevant information you provide, within the scope of legal and regulatory requirements and company policies. If any non-compliant behavior is confirmed, DaSouChe Group will take strict actions to address it.",
      },
    },
  },
  components: {
    MyHeader,
    SectionTitle,
    MyFooter,
    GroupHead,
  },
  head() {
    return {
      title: this.$t("title"),
    };
  },
};
</script>

<style lang="less" scoped>
.page-content {
  position: relative;
}

#page2-partical {
  position: absolute;
  top: 400px;
  left: 0;
  right: 0;
  height: 544px;
  z-index: -1;
}

.join-us-root {
  margin-top: 156px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 275px;
  background: linear-gradient(238.88deg, #ffd9cb 0%, rgba(255, 217, 203, 0) 44.73%);

  .img-so {
    width: 368px;
    height: 362px;
    flex-shrink: 0;
    position: absolute;
    bottom: 0;
    transform: translateX(-110%);
  }

  .info {
    transform: translateX(0%);
    flex-shrink: 0;
    margin-left: 60px;
    display: flex;
    flex-direction: column;

    .title {
      font-weight: 500;
      font-size: 32px;
      line-height: 36px;
      width: fit-content;
      display: flex;
      align-items: center;
      color: #2b2c2e;
      position: relative;

      .bg {
        background: #ff571a;
        width: 31px;
        height: 19px;
        position: absolute;
        bottom: -2px;
        right: 40px;
        opacity: 0.7;
        z-index: -1;
      }

      .arrow-job {
        width: 45px;
        height: 45px;
        margin-left: 10px;
      }
    }

    .sub {
      font-weight: 300;
      font-size: 20px;
      line-height: 28px;
      color: #b4b5b7;
      margin-top: 11px;
    }

    .contact {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 34px;
      margin-top: 30px;
      color: #2b2c2e;
    }
  }
}

.send-email {
  margin-top: 40px;
  align-self: center;
  width: 231px;
  height: 48px;
  border: 1px solid #ff571a;
  border-radius: 4px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 20px;
  color: #ff571a;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background: #ff571a;
    color: white;
    transition: all ease 0.2s;
  }
}

.compliance {
  max-width: 1048px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #2b2c2e;
  align-self: center;
  margin-top: 47px;

  .email {
    color: #ff571a;
  }
}

.cooperation {
  margin: 59px auto 0 auto;
  width: 1100px;
  height: 354px;
  position: relative;

  .layer1 {
    background: linear-gradient(180deg, #f1f3f8 0%, #ffffff 100%);
    box-shadow: 1px 5px 12px #f4f1f0;
    border-radius: 4px;
    width: 1056px;
    height: 300px;
    top: 40px;
    position: relative;
    display: flex;
    overflow: hidden;
    align-items: center;
    padding-left: 48px;
    box-sizing: border-box;

    .cooperation-info {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #2b2c2e;
    }

    .group {
      display: flex;
      flex-direction: column;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 34px;
      color: #2b2c2e;

      &:last-child {
        margin-left: 40px;
      }

      .item {
        &:not(:first-child) {
          margin-top: 10px;
        }
      }
    }
  }

  .layer2 {
    width: 112px;
    height: 88px;
    background: #ff571a;
    mix-blend-mode: normal;
    opacity: 0.7;
    border-radius: 4px;
    position: absolute;
    bottom: 0px;
    right: -44px;
  }

  .layer3 {
    width: 480px;
    height: 310px;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
  }
}

.workspace {
  display: flex;
  justify-content: center;
  margin-top: 72px;

  .item {
    width: 540px;
    height: 250px;
    position: relative;
    display: flex;
    justify-content: end;
    align-items: center;

    .img {
      width: 420px;
      height: 250px;
      display: block;
      overflow: hidden;
      border-radius: 4px;
      position: absolute;
      left: 0;
      top: 0;
    }

    .txt-container {
      background: linear-gradient(270deg, #f6f7fb 0.94%, #ffffff 100%);
      border-radius: 4px;
      width: 320px;
      min-height: 156px;
      padding: 18px 28px;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;

      .title {
        font-style: normal;
        font-weight: 400;
        font-size: 24px;
        line-height: 32px;
        color: #2b2c2e;
        margin-bottom: 10px;
      }

      .sub {
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        line-height: 24px;
        color: #2b2c2e;
        display: flex;
        overflow: hidden;
      }

      .label {
        flex-shrink: 0;
      }

      .value {
        flex: 1;
      }
    }
  }
}

.jobs {
  margin-top: 60px;
  display: flex;
  background-color: white;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-bottom: 100px;
  gap: 32px;

  .job-card {
    display: flex;
    flex-direction: column;
    background-color: white;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0px 2px 8px #f4f1f0;
    min-width: 378px;
    align-self: stretch;

    .top {
      height: 65px;
      line-height: 65px;
      padding-left: 28px;
      background-color: #c7ecff;
      font-family: PingFang SC;
      font-weight: 500;
      font-style: Medium;
      font-size: 24px;
      flex-shrink: 0;
    }

    .list {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      padding: 30px 28px;
      gap: 16px;

      .item {
        font-family: PingFang SC;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
        color: #000000;
        cursor: pointer;
        text-decoration: none;

        &:hover {
          color: #ff571a;
        }
      }
    }
  }

  .job-card-2 {
    .top {
      background-color: #c7d4ff;
    }
  }

  .job-card-3 {
    .top {
      background-color: #ffd2c7;
    }
  }
}

@media screen and (min-width: 540px) {
  .label-en {
    width: 38px;
  }

  .value-en {
    // margin-left: 4px;
  }

  .integrity {
    margin-top: 70px;
  }

  .workspace {
    .item {
      &:last-child {
        margin-left: 42px;
      }
    }
  }
}

@media screen and (max-width: 540px) {
  .jobs {
    flex-direction: column;
    margin: 0 16px;
    margin-top: 19px;
    gap: 16px;
    padding-bottom: 32px;
    background-color: white;

    .job-card {
      min-width: unset;
      .top {
        padding-left: 25px;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
      }

      .list {
        gap: 14px;
        padding: 25px;

        .item {
          font-size: 15px;
        }
      }
    }
  }

  .label-en {
    width: 30px;
  }

  .value-en {
    // margin-left: 4px;
  }

  .join-us-root {
    margin-top: 50px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 124px;
    background: linear-gradient(0deg, rgba(255, 217, 203, 0.6) 0%, rgba(255, 217, 203, 0) 100%);
    background-repeat: no-repeat;
    background-size: cover;

    .img-so {
      width: 144px;
      height: 124px;
      flex-shrink: 0;
      position: absolute;
      bottom: 0;
      transform: translateX(-75%);
    }

    .info {
      transform: translateX(20%);
      flex-shrink: 0;
      margin-left: 60px;
      display: flex;
      flex-direction: column;

      .title {
        font-size: 16px;
        line-height: 18px;
        position: relative;

        .bg {
          background: #ff571a;
          width: 20px;
          height: 12px;
          position: absolute;
          bottom: -4px;
          right: -10px;
          opacity: 0.7;
          z-index: -1;
        }

        .arrow-job {
          display: none;
        }
      }

      .sub {
        font-size: 10px;
        line-height: 14px;
        margin-top: 5px;
      }

      .contact {
        font-size: 14px;
        line-height: 17px;
        margin-top: 16px;
      }
    }
  }

  .integrity {
    margin-top: 194px;
  }

  .send-email {
    margin-top: 22px;
    align-self: center;
    width: 115px;
    height: 24px;
    border: 1px solid #ff571a;
    border-radius: 2px;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 10px;
    color: #ff571a;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: none;
    text-decoration: none;

    &:hover {
      background: #ff571a;
      color: white;
      transition: all ease 0.2s;
    }
  }

  .cooperation-mob {
    margin-top: 19px;
    position: relative;

    &-img {
      width: 100%;
      height: auto;
    }

    &-info {
      width: calc(100% - 28px);
      margin-left: 14px;
      background: linear-gradient(180deg, #f1f3f8 0%, #ffffff 100%);
      box-shadow: 1px 2px 6px #f4f1f0;
      border-radius: 2px;
      bottom: -149px;
      position: absolute;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 21px;
      color: #2b2c2e;
      padding: 20px;
      box-sizing: border-box;
    }

    &-info-en {
      font-size: 12px;
      line-height: 19px;
    }
  }

  .workspace {
    display: flex;
    justify-content: unset;
    flex-direction: column;
    margin-top: 19px;

    .item {
      width: 100%;
      height: auto;
      position: relative;
      flex-direction: column;

      &:last-child {
        margin-top: -44px;
        margin-bottom: -44px;
      }

      .img {
        width: 100%;
        height: auto;
        display: block;
        overflow: hidden;
        border-radius: 2px 2px 0 0;
        position: static;
      }

      .txt-container {
        background: linear-gradient(180deg, #f1f3f8 0%, #ffffff 100%);
        box-shadow: 1px 2px 6px #f4f1f0;
        border-radius: 2px;
        width: calc(100% - 28px);
        height: auto;
        min-height: unset;
        margin: 0 14px;
        position: relative;
        bottom: unset;
        top: -60px;
        padding: 20px;
        box-sizing: border-box;
        overflow: hidden;
        word-wrap: break-word;

        .title {
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 16px;
          color: #2b2c2e;
          margin-bottom: 5px;
        }

        .sub {
          font-weight: 400;
          font-style: normal;
          font-size: 13px;
          line-height: 21px;
          color: #2b2c2e;
          display: flex;
          overflow: hidden;
        }

        .label {
          flex-shrink: 0;
        }
      }
    }
  }

  .compliance {
    font-size: 13px;
    line-height: 22px;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/_lang/html/contact-us/index.vue